function encodeUrlValue(value: string): string {
  return value?.split("+").join("%2B");
}

function buildQueryString(params: Record<string, any>): string {
  let queryString = "";
  if (params) {
    const objKeys = Object.keys(params);
    if (objKeys && objKeys.length > 0) {
      objKeys.forEach((key) => {
        if (params[key]) {
          const value = params[key];
          if (queryString === "") {
            queryString += key + "=" + encodeUrlValue(value);
          } else {
            queryString += "&" + key + "=" + encodeUrlValue(value);
          }
        }
      });
    }
  }
  return queryString;
}

export function buildUrlWithQueryString(url: string, params: Record<string, any>): string {
  let buildUrl = url;
  const queryString = buildQueryString(params);
  if (queryString && queryString.length > 0) {
    buildUrl += "?" + queryString;
  }
  return buildUrl;
}
